export class UsersEndpoint {
  static assistanceProviderUsers(brand: string): string {
    return `/${brand.toLowerCase()}/assistanceproviderusers`;
  }

  static customers(brand: string): string {
    return `/${brand.toLowerCase()}/customers`;
  }

  static partnerUsers(brand: string): string {
    return `/${brand.toLowerCase()}/partnerusers`;
  }

  static underwriterUsers(brand: string): string {
    return `/${brand.toLowerCase()}/underwriterusers`;
  }

  static token(brand: string): string {
    return `/${brand.toLowerCase()}/token`;
  }

  static tokenExchange(brand: string): string {
    return `/${brand.toLowerCase()}/tokenexchange`;
  }

  static settings(brand: string): string {
    return `/${brand.toLowerCase()}/settings`;
  }

  static user(brand: string): string {
    return `/${brand.toLowerCase()}/customers`;
  }

  static kosmosCreateAccount(): string {
    return `/Member/VerifyGuest`;
  }

  static kosmosLogin(): string {
    return `/account`;
  }
}
